export default {
  personsName: 'personsName',
  programName: 'programName',
  _class: '_class',
  hometown: 'hometown',
  major: 'major',
  quote: 'quote',
  body: 'body',
  favActivities: 'favActivities',
  favHangout: 'favHangout',
  bestPlaceToEat: 'bestPlaceToEat',
  favEvent: 'favEvent',
  favTradition: 'favTradition',
  travel: 'travel',
  submitBtn: 'submit-profile-update-btn',
  cancelBtn: 'cancel-profile-update-btn',
  deleteBtn: 'delete-profile-btn',
  updateProfileForm: 'update-profile-form',
  header: 'form-header',
};
